// src/components/GelatoCostCalculator.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export default function GelatoCostCalculator() {
  const [recipes, setRecipes] = useState([]);
  const [prices, setPrices] = useState({});
  const [sorted, setSorted] = useState(false);
  const [showPerKg, setShowPerKg] = useState(false); // 👈 Toggle state

  useEffect(() => {
    const fetchData = async () => {
      const recipesSnap = await getDocs(collection(db, 'recipes'));
      const stockSnap = await getDocs(collection(db, 'stock_store'));

      const stockMap = {};
      stockSnap.forEach((doc) => {
        const data = doc.data();
        const code = doc.id.toUpperCase();
        stockMap[code] = data.pricePerKg || null;
      });

      const recipeList = [];
      recipesSnap.forEach((doc) => {
        const data = doc.data();

        // Exclude water from ingredients
        const filteredIngredients = data.ingredients.filter(
          (ing) => !(ing.product || '').toLowerCase().includes('water')
        );

        const totalGrams = filteredIngredients.reduce(
          (sum, ing) => sum + ing.amount_g,
          0
        );

        const costPerPan = filteredIngredients.reduce((sum, ing) => {
          const code = (ing.code || '').toUpperCase();
          const price = stockMap[code];
          if (!price) return sum;
          return sum + (ing.amount_g / 1000) * price;
        }, 0);

        recipeList.push({
          name: data.name,
          ingredients: filteredIngredients,
          costPerPan: parseFloat(costPerPan.toFixed(2)),
          costPerKg: parseFloat(
            (costPerPan / (totalGrams / 1000)).toFixed(2)
          ),
        });
      });

      setRecipes(recipeList);
      setPrices(stockMap);
    };

    fetchData();
  }, []);

  const sortedRecipes = sorted
    ? [...recipes].sort((a, b) =>
        showPerKg ? b.costPerKg - a.costPerKg : b.costPerPan - a.costPerPan
      )
    : recipes;

  return (
    <div className="gelato-cost">
      <h2>💸 Gelato Cost Calculator</h2>

      <div className="gelato-cost-controls">
        <button
          type="button"
          className="btn"
          onClick={() => setSorted(!sorted)}
        >
          {sorted ? '↩️ Reset Order' : '⬆️ Sort by Most Expensive'}
        </button>
        <button
          type="button"
          className="btn"
          onClick={() => setShowPerKg(!showPerKg)}
        >
          {showPerKg ? '📦 Show €/pan' : '⚖️ Show €/kg'}
        </button>
      </div>

      {sortedRecipes.map((r, idx) => (
        <div key={idx} className="gelato-cost-card">
          <h3 className="gelato-cost-title">{r.name}</h3>
          <p className="gelato-cost-summary">
            <strong>
              {showPerKg ? 'Avg Cost per kg:' : 'Total Cost per Pan:'}
            </strong>{' '}
            €{showPerKg ? r.costPerKg : r.costPerPan}
          </p>

          <div className="gelato-ingredients-grid">
            {r.ingredients.map((ing, i) => {
              const code = (ing.code || '').toUpperCase();
              const price = prices[code];
              const cost = price
                ? ((ing.amount_g / 1000) * price).toFixed(2)
                : '—';
              return (
                <div key={i} className="gelato-ingredient-card">
                  <strong>{ing.product}</strong>
                  <br />
                  {ing.amount_g}g @ {price ? `€${price}/kg` : '—'}
                  <br />
                  = <strong>€{cost}</strong>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
